import { DataModel } from '../../dto/dto.js';
import { Price } from '../price.js';

export abstract class CartItemDto extends DataModel {
  abstract get uniqueId(): string;
  abstract get quantity(): number;
  abstract get unitPrice(): Price;
  abstract get originalUnitPrice(): Price | null;
  abstract get totalPrice(): Price;
}
